import axios from "axios";

export const URL = "https://api.tburudaniplus.co.tz";

// Create axios instance with default config
export const axiosInstance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the auth token in all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("tburudani_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle unauthorized errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      window.dispatchEvent(new CustomEvent("unauthorized", { detail: error.response.status }));
    }
    return Promise.reject(error);
  }
);

export const getCategories = async () => {
  return (await axiosInstance.get("/categories")).data;
};

export const getMovies = async () => {
  return (await axiosInstance.get("/movies")).data;
};
export const getMoviesById = async (id) => {
  return (await axiosInstance.get(`/admin/movie/${id}`)).data;
};

export const getSeriesById = async (id) => {
  return (await axiosInstance.get(`/admin/series/${id}`)).data;
};

export const getUserById = async (id) => {
  return (await axiosInstance.get(`/admin/user/${id}`)).data;
};

export const getSeries = async () => {
  return (await axiosInstance.get("/admin/series")).data;
};

export const addBanner = async (data) => {
  return (
    await axiosInstance.post("/admin/banner", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const getBannerById = async (id) => {
  return (await axiosInstance.get(`/admin/banner/${id}`)).data;
};

export const updateBanner = async (data) => {
  return (
    await axiosInstance.put(`/admin/banner/${data?.id}`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const addCategory = async (data) => {
  return (await axiosInstance.post("/admin/category", data)).data;
};

export const updateCategory = async (data) => {
  return (await axiosInstance.put(`/admin/category/${data?.id}`, data.data))
    .data;
};

export const getCategoryById = async (id) => {
  return (await axiosInstance.get(`/category/${id}`)).data;
};

export const getGenres = async () => {
  return (await axiosInstance.get("/admin/genres")).data;
};
export const getLanguage = async () => {
  return (await axiosInstance.post("/languages")).data;
};

export const addMovie = async (data) => {
  return (
    await axiosInstance.post("/admin/movie", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const updateMovie = async (data) => {
  return (
    await axiosInstance.put(`/admin/movie/${data?.id}`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const toggleMovieStatus = async (id, isEnabled) => {
  return (
    await axiosInstance.put(`/admin/movie/${id}/toggle-status`, { isEnabled })
  ).data;
};

export const addSeries = async (data) => {
  return (
    await axiosInstance.post("/admin/series", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const toggleSeriesStatus = async (id, isEnabled) => {
  return (
    await axiosInstance.put(`/admin/series/${id}/toggle-status`, { isEnabled })
  ).data;
};

export const updateSeries = async (data) => {
  return (
    await axiosInstance.put(`/admin/series/${data?.id}`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const addUser = async (data) => {
  return (await axiosInstance.post("/admin/user", data)).data;
};

export const updateUser = async (data) => {
  return (await axiosInstance.put(`/admin/user/${data?.id}`, data.data)).data;
};

export const addSubCategory = async (data) => {
  return (await axiosInstance.post("/admin/subcategory", data)).data;
};

export const updateSubCategory = async (data) => {
  return (await axiosInstance.put(`/admin/subcategory/${data?.id}`, data.data))
    .data;
};

export const getSubcategoryById = async (id) => {
  return (await axiosInstance.get(`/subcategory/${id}`)).data;
};

export const addSubscription = async (data) => {
  return (await axiosInstance.post("/admin/subscription", data)).data;
};

export const updateSubscription = async (data, id) => {
  return (await axiosInstance.put(`/admin/subscription/${id}`, data)).data;
};

export const getSubcritpionById = async (id) => {
  return (await axiosInstance.get(`/admin/subscription/${id}`)).data;
};

export const addComingSoon = async (data) => {
  return (
    await axiosInstance.post("/admin/upcoming", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const updateComingSoon = async (data) => {
  return (
    await axiosInstance.put(`/admin/upcoming/${data?.id}`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const getComingSoonById = async (id) => {
  return (await axiosInstance.get(`/upcoming-id/${id}`)).data;
};

export const getDashboard = async () => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getBanners = async () => {
  try {
    const response = await axiosInstance.get(`/admin/banners`);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllMovies = async (
  page = 1,
  limit = 50,
  status,
  type,
  search
) => {
  try {
    let url = `/admin/movies?page=${page}&limit=${limit}`;
    if (status) {
      url += `&status=${status}`;
    }
    if (type) {
      url += `&type=${encodeURIComponent(type)}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await axiosInstance.get(url);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const getAllSoon = async () => {
  try {
    const response = await axiosInstance.get(`/upcoming`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateSoon = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/upcoming/${id}`, data);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteSoon = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/upcoming/${id}`);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addSoon = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/upcoming`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllSeries = async (page = 1, limit = 50, status, search) => {
  try {
    let url = `/admin/series?page=${page}&limit=${limit}`;
    if (status) {
      url += `&status=${status}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await axiosInstance.get(url);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllCategories = async () => {
  try {
    const response = await axiosInstance.get(`/categories`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const createNewBanner = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/banner`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteBanner = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/banner/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/category/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getSubCategories = async (id) => {
  try {
    const response = await axiosInstance.get(`/category/${id}/subcategory`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteSubCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/subcategory/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addMovietoSubCategory = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory/add-movie`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addSeriesToSubCategory = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory/add-series`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const removeMovieFromSubCategory = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory/remove-movie`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const removeSeriesFromSubCategory = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory/remove-series`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const changeSeriesPosition = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory-update/series-position`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const changeMoviePosition = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subcategory-update/movie-position`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllGenres = async () => {
  try {
    const response = await axiosInstance.get(`/admin/genres`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const getAllTransaction = async (page = 1) => {
  try {
    const response = await axiosInstance.get(
      `/admin/transactions?page=${page}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const getAllActiveSubs = async () => {
  try {
    const response = await axiosInstance.get(`/admin/active-subscriptions`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllNonActiveSubs = async (page = 1, limit = 20) => {
  try {
    const response = await axiosInstance.get(
      `/admin/non-active-subscriptions?page=${page}&limit=${limit}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addGenre = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/genre`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const addLanguage = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/language`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const updateGenre = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/genre/${id}`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
export const updateLanguage = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/language/${id}`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteMovie = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/movie/${id}`);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteComingSoon = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/upcoming/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteSeries = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/series/${id}`);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addEpisode = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/episode`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateEpisode = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/episode/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const toggleEpisodeStatus = async (id, isEnable) => {
  try {
    const response = await axiosInstance.put(`/admin/episode/${id}`, {
      isEnable,
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteEpisode = async (data) => {
  try {
    const response = await axiosInstance.delete(
      `/admin/episode/${data.episodeId}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getAllUsers = async (page, limit, search) => {
  try {
    const response = await axiosInstance.get(
      `/admin/users?page=${page}&limit=${limit}&search=${search || ""}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/user/${id}`);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getUserNotication = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/user-notifications/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addUserNotification = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/notification`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const loginAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/login`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateUserImage = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/user-image/${id}`, data);

    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addCastToMovie = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/add-movie-cast/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addCastToSeries = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/series-cast/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addSubscribtion = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/subscription`, data);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const updateUserSubscription = async (data, id) => {
  try {
    const response = await axiosInstance.put(`/admin/user-subscription`, data);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const getAllSubscribtions = async () => {
  try {
    const response = await axiosInstance.get(`/admin/subscriptions`);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const subscribtionsCheckMovie = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/subscription-movie/${id}`);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const subscribtionsCheckSeries = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/admin/subscription-series/${id}`
    );
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const addDataToSubcription = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/subscription/add-video`,
      data
    );
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const deleteSubscription = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/subscription/${id}`);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const sendSubscriptionReminder = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/admin/subscription-reminder`,
      data
    );
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const getAllUserRent = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/user-rent/${id}`);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const addDatatoRent = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/user-add-rent`, data);
    if (response.status === 200) {
      return [true, response.data];
    }
    return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const getSystemValues = async () => {
  try {
    const response = await axiosInstance.get(`/system-values`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateSystemValues = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/system-values`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const userSubHistory = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/admin/user-subscription-history/${id}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const removeMovieCast = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/remove-movie-cast`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};
export const removeSeriesCast = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/remove-series-cast`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const userSerach = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/user-search`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const addPoster = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/singlebanner`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const getPoster = async () => {
  try {
    const response = await axiosInstance.get(`/single-banner`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const deletePoster = async () => {
  try {
    const response = await axiosInstance.delete(`/admin/singlebanner`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const updatePoster = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/singlebanner`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const deleteUpcoming = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/upcoming/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const deleteAdmin = async (id) => {
  const { data: res } = await axiosInstance.delete(`/admin/delete-admin/${id}`);
  return res;
};

export const updateAdmin = async (data, id) => {
  const response = await axiosInstance.put(`/admin/admin-update/${id}`, data);
  return response.data;
};

export const addAdmin = async (data2) => {
  const { data } = await axiosInstance.post(`/admin/signup`, data2);
  return data;
};
export const getAllAdmins = async () => {
  const { data: res } = await axiosInstance.get(`/admin/all-admin`);
  return res;
};

export const getDisabledUsers = async (page = 1, limit = 20, search) => {
  try {
    const response = await axiosInstance.get(
      `/admin/disabled-users?page=${page}&limit=${limit}&search=${search}`
    );
    return [true, response.data];
  } catch (error) {
    return [false, error.response?.data?.message || "Something went wrong"];
  }
};

export const enableUsers = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/enable-users`, data);
    return [true, response.data];
  } catch (error) {
    return [false, error.response?.data?.message || "Something went wrong"];
  }
};

export const disableUsers = async (data) => {
  try {
    const response = await axiosInstance.put(`/admin/disable-users`, data);
    return [true, response.data];
  } catch (error) {
    return [false, error.response?.data?.message || "Something went wrong"];
  }
};

export const assignSubscriptionToUsers = async (data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/multiple-user-subscription`,
      data
    );
    return [true, response.data];
  } catch (error) {
    return [false, error];
  }
};

// Season APIs
export const getSeasonsBySeries = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/seasons-series/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getSeasonById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/season/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addSeason = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/season`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateSeason = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/season/${id}`, data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteSeason = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/season/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getEpisodesBySeasonId = async (
  id,
  page = 1,
  limit = 10,
  search = "",
  isEnable
) => {
  try {
    let url = `/admin/episodes-season/${id}?page=${page}&limit=${limit}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    if (isEnable !== undefined) {
      url += `&isEnable=${isEnable}`;
    }

    const response = await axiosInstance.get(url);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

// Creator endpoints
export const getAllCreators = async (
  page = 1,
  limit = 10,
  search = "",
  filters = {}
) => {
  try {
    let url = `/admin/creators?page=${page}&limit=${limit}`;

    // Add search parameter
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    // Add any additional filters to the query string
    if (filters.isVerified !== undefined) {
      url += `&isVerified=${filters.isVerified}`;
    }

    const response = await axiosInstance.get(url);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getCreatorById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/creator/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addCreator = async (data) => {
  try {
    // Check if data is FormData and set appropriate Content-Type
    const config =
      data instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

    const response = await axiosInstance.post(`/admin/creator`, data, config);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateCreator = async (id, data) => {
  try {
    // Check if data is FormData and set appropriate Content-Type
    const config =
      data instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

    const response = await axiosInstance.put(
      `/admin/creator/${id}`,
      data,
      config
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteCreator = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/creator/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateContentStatus = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/content-status", data);
    return [true, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getMethod = async (url) => {
  const response = await axiosInstance.get(url);

  return response;
};

export const postMethod = async (url, data) => {
  const response = await axiosInstance.post(url, data);
  return response;
};

export const putMethod = async (url, data) => {
  const response = await axiosInstance.put(url, data);
  return response;
};

export const deleteMethod = async (url) => {
  const response = await axiosInstance.delete(url);
  return response;
};

// Comment management APIs
export const getMovieComments = async (id, page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/admin/movie-comments/${id}?page=${page}&limit=${limit}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getEpisodeComments = async (id, page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/admin/episode-comments/${id}?page=${page}&limit=${limit}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateComment = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/comment/${id}`, {
      isApproved: data.isApproved,
      text: data.text,
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteComment = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/comment/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getWHTReport = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(
      `/admin/wht-report?startDate=${startDate}&endDate=${endDate}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getVATReport = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(
      `/admin/vat-report?startDate=${startDate}&endDate=${endDate}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

// WhatsApp Notification APIs
export const sendWhatsAppTest = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/twilio/test", data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const sendWhatsAppProduction = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/twilio/send", data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const sendWhatsAppSheet = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/twilio/send-sheet", data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

// Update cast APIs
export const updateMovieCast = async (data) => {
  try {
    const response = await axiosInstance.put("/admin/update-movie-cast", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const updateSeriesCast = async (data) => {
  try {
    const response = await axiosInstance.put(
      "/admin/update-series-cast",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const generatePaymentLink = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/payment-link", data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const getCreatorRevenue = async (id, startDate, endDate) => {
  try {
    const response = await axiosInstance.post(`/admin/creator-revenue/${id}`, {
      startDate,
      endDate,
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const getAllVerticalSeries = async (page = 1, limit = 50, search) => {
  try {
    let url = `/admin/vertical-series?page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await axiosInstance.get(url);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getVerticalSeriesById = async (id) => {
  return (await axiosInstance.get(`/admin/vertical-series/${id}`)).data;
};

export const addVerticalSeries = async (data) => {
  return (
    await axiosInstance.post("/admin/vertical-series", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const updateVerticalSeries = async (data) => {
  return (
    await axiosInstance.put(`/admin/vertical-series/${data?.id}`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  ).data;
};

export const deleteVerticalSeries = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/vertical-series/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addCastToVerticalSeries = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/vertical-series-cast/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateVerticalSeriesCast = async (data) => {
  try {
    const response = await axiosInstance.put(
      "/admin/update-vertical-series-cast",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error.response?.data || error];
  }
};

export const removeVerticalSeriesCast = async (data) => {
  try {
    const response = await axiosInstance.put(
      "/admin/remove-vertical-series-cast",
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (err) {
    return [false, err];
  }
};

export const getVerticalEpisodesBySeriesId = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/vertical-episodes/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getVerticalEpisodeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/vertical-episode/${id}`);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addVerticalEpisode = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/vertical-episode", data);
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const updateVerticalEpisode = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/admin/vertical-episode/${id}`,
      data
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const deleteVerticalEpisode = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `/admin/vertical-episode/${id}`
    );
    if (response.status === 200) return [true, response.data];
    else return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const toggleVerticalSeriesStatus = async (id, isEnabled) => {
  return (
    await axiosInstance.put(`/admin/vertical-series/${id}`, {
      isEnable: isEnabled,
    })
  ).data;
};

// Live Channels
export const getLiveChannels = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(`/admin/live-channels?page=${page}&limit=${limit}`);
    if (response.status === 200) return [true, response.data];
    return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const getLiveChannelById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/live-channel/${id}`);
    if (response.status === 200) return [true, response.data];
    return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};

export const addLiveChannel = async (data) => {
  return (
    await axiosInstance.post("/admin/live-channel", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
};

export const updateLiveChannel = async (data) => {
  return (
    await axiosInstance.put(`/admin/live-channel/${data.id}`, data.data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
};

export const deleteLiveChannel = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/live-channel/${id}`);
    if (response.status === 200) return [true, response.data];
    return [false, response.data];
  } catch (error) {
    return [false, error];
  }
};
